"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracking = void 0;
var pinpo_model_kit_1 = require("pinpo-model-kit");
var Segment_1 = require("./Segment");
var PhoneHelper_1 = require("./helpers/PhoneHelper");
/* Usefull for prevent error from Segment when not load yet */
var segmentPage = function (name, routeParams) {
    if (!Segment_1.Segment.analytics().IS_IT_NOT_READY) {
        if (name || routeParams) {
            Segment_1.Segment.analytics().page(name || "Page", routeParams);
        }
        else {
            Segment_1.Segment.analytics().page();
        }
    }
    else {
        setTimeout(function () {
            segmentPage(name, routeParams);
        }, 100);
    }
};
var Tracking = {
    page: function (component) {
        if (component) {
            var routeParams = {
                path: component.props.match.path,
                params: JSON.stringify(component.props.match.params)
            };
            try {
                segmentPage(component.displayName, routeParams);
            }
            catch (e) {
                console.error(e);
            }
        }
        else {
            segmentPage();
        }
    },
    track: function (name, details) {
        Segment_1.Segment.analytics().track(name, details);
    },
    registerUser: function (user) {
        Segment_1.Segment.analytics().alias(user.get("username"));
    },
    identifyUser: function (user) {
        /* Anonymous identification forbidden */
        if (!user) {
            return;
        }
        /* Segment identification */
        Segment_1.Segment.analytics().identify(user.get("email"), {
            id: user.id,
            email: user.get("email"),
            phone: PhoneHelper_1.PhoneHelper.phoneNumberOfParts({
                phoneNumber: user.get("phone"),
                countryCode: user.get("countryCode")
            }),
            name: pinpo_model_kit_1.User.fullName(user),
            language: user.get("preferredLanguage"),
            isAgent: !!user.get("agentProfile"),
            region: user.get("region")
        });
    },
    clearUser: function () {
        Segment_1.Segment.analytics().reset();
        Segment_1.Segment.analytics().ready(function () { window.mixpanel.cookie.clear(); });
    }
};
exports.Tracking = Tracking;
//# sourceMappingURL=Tracking.js.map